import React from 'react';
import { connect } from 'react-redux';
import { Switch } from 'react-router-dom';
import { PublicRoute, PrivateRoute } from './components/Routes';
import CreateContract from './views/contracts/CreateContract';
import SignContract from './views/contract_sign/SignContract';
import EditContract from './views/contract_edit/EditContract';
import Login from './views/Login';
import Home from './views/Home';
import ShowContract from './views/contract_show/ShowContract';
import NotFound from './views/NotFound';
import WebpayPaymentReceipt from './components/webpay/feedback/index';

const Routes = () => {
  return (
    <Switch>
      <PublicRoute restricted={true} path="/" exact component={Login} />
      <PublicRoute restricted={true} extrict path="/login" component={Login} />
      <PublicRoute path="/contract/make_contract" exact component={CreateContract} />
      <PublicRoute path="/contract/make_contract/:params" exact component={CreateContract} />
      <PublicRoute path="/contract/sign_contract/:params" exact component={SignContract} />
      <PublicRoute path="/contract/edit_contract/:params" exact component={EditContract} />
      <PublicRoute path="/contract/show_contract/:params" exact component={ShowContract} />
      <PublicRoute path="/contract/payment_confirmation/:body/:iv" extrict exact component={WebpayPaymentReceipt} />
      <PrivateRoute
        exact
        strict
        path={[
          '/contracts',
          '/contracts/contract_detail/:params',
          '/contracts/admin/edit_contract/:params',
          '/account/profile',
          '/coupons',
          '/dashboard'
        ]}
        component={Home}
      />
      <PublicRoute component={NotFound} />
    </Switch>
  );
};

export default connect(null, null)(Routes);
